<template>
    <div>
        <header class="page-header">{{decodeURIComponent(workJson.workname)}}</header>
        <div class="page-container">
            <div class="subject-container">
                <div class="subject-left" style="background-color:#f6fcff;">
                    <div class="subject-top">
                        <!--  左侧内容  -->
                        <div class="subject-title">题面</div>
                        <!--  题面图片容器  -->
                        <div class="theme-box">
                            <div class="swiper-container">
                                <div class="swiper-wrapper">
                                    <div class="swiper-slide" :data-value="index"
                                         v-for="(item,index) in picUrls">
                                        <img class="item-img"
                                             style="max-height: 100%;max-width: 92%;width: 90%;height: 100%;"
                                             :src="item" v-on:click="previewAnswerImg(picUrls,index)">
                                    </div>
                                </div>
                                <!-- Add Pagination -->
                                <div class="swiper-pagination"></div>
                                <!-- Add Arrows -->
                                <div class="swiper-button-next"></div>
                                <div class="swiper-button-prev"></div>
                            </div>
                        </div>
                    </div>
                    <!--整体报告-->
                    <div class="subject-statistics">
                <span class="footer-left">
                    <span class="title">整体报告</span>
                </span>
                        <div class="overallReport"
                             v-if="commitStudents.length!=0">
                            <div class="answerCondition">
                                <div class="overallTitle">答题情况</div>
                                <div class="answerReport">
                                    <p>题型：<span>{{getQuestype(workJson.workjson.questype)}}</span></p>
                                    <p>用时：</p>
                                    <p>参与：<span>{{submitCount}}/{{totalStudentCount}}</span></p>
                                    <p>班级：<span>{{decodeURIComponent(JSON.parse(workJson.workjson).classname)}}</span>
                                    </p>
                                </div>
                            </div>
                            <div class="noSubmitList">
                                <div class="overallTitle">未提交</div>
                                <div class="noSubListCont">
                                    <span v-if="commitStudents.indexOf(item) === -1"
                                          v-for="item in Object.keys(students)">{{students[item]}}</span>
                                    <p class="allSubmit" v-if="submitCount === totalStudentCount">
                                        本次课堂互动全部学生已参加</p>
                                </div>
                                <!--<div class="decreaseButton">-->
                                <!--一键评价（-5）-->
                                <!--</div>-->
                            </div>
                        </div>
                        <div class="reportNull" v-else>
                            <p class="reportShow defaultShow"></p>
                        </div>
                    </div>
                </div>
                <div class="subject-right">
                    <!--  右侧内容  -->
                    <div class="reportTitle">
                        <span>答题报告</span>
                    </div>
                    <ul class="result-list list-none">
                        <template v-for="(item,index) in commitStudents" v-if="activePattern===1">
                            <li class="comprehensive-li" :data-uid="item"
                                v-if="raisehandsList.indexOf(item) == -1"
                                v-on:click="previewAnswerImg(studentAnswer[item][0].picUrls)">
                                <img class="pic" :src="studentAnswer[item][0].picUrls[0]"
                                     style="max-width: 100%;max-height:100%"/>
                                <span class="stu-name">{{studentAnswer[item][0].picUrls.length}}张</span>
                                <p class="subName">{{students[item]}}</p>
                            </li>
                            <li class="comprehensive-li putHand" :data-uid="item"
                                v-on:click="previewAnswerImg(studentAnswer[item][0].picUrls)" v-else>
                                <img class="pic" :src="studentAnswer[item][0].picUrls[0]"
                                     style="max-width: 100%;max-height:100%"/>
                                <span class="stu-name">{{studentAnswer[item][0].picUrls.length}}张</span>
                                <p class="subName">{{students[item]}}</p>
                            </li>
                        </template>
                        <template v-for="(item,index) in commitStudents" v-if="activePattern===2">
                            <span class="listPerson" :data-uid="item" v-if="raisehandsList.indexOf(item) == -1"
                                  v-on:click="previewAnswerImg(studentAnswer[item][0].picUrls)">{{students[item]}}</span>
                            <span class="listPerson putHands" :data-uid="item"
                                  v-on:click="previewAnswerImg(studentAnswer[item][0].picUrls)" v-else>{{students[item]}}</span>
                        </template>
                    </ul>
                </div>
            </div>
        </div>
        <div class="setAnswer" style="display: block">
            <ul>
                <li class="photoPattern activePattern" v-on:click="changePhotoPattern($event)">图片模式</li>
                <li class="listPattern" v-on:click="changeListPattern($event)">名单模式</li>
            </ul>
        </div>
        <!-- 预览轮播 -->
        <!--<preview-slider-->
            <!--ref="previewSlider"-->
            <!--:previewMode="previewMode"-->
            <!--:previewVideoMode="previewVideoMode"-->
            <!--:videoSrc="videoSrc"-->
            <!--@closePreview="closePreview"-->
        <!--&gt;</preview-slider>-->

        <!-- 预览轮播 -->
        <dt-preview-slider
                ref="previewSlider"
                :previewMode="previewMode"
                :previewVideoMode="previewVideoMode"
                :videoSrc="videoSrc"
                @closePreview="closePreview"
        ></dt-preview-slider>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import * as API from '../../../../service/cloudReport/index'
    // const previewSlider = () => import("../baseData/previewSlider");

    export default {
        name: "subject-report",
        computed: {
            ...mapGetters([
                'interactPath',
                'interactPBPath'
            ]),
        },
        // components: {
        //     previewSlider
        // },
        data () {
            return {
                workId: this.$route.params.workId,
                userListPB: null,
                questionInfoPb: null,
                calcPB: null,
                quesDetailsPb: null,
                students: [],
                workJson: '',//pb文件中取出的报告json
                workjson: '',
                picUrls: [],//题目集合,
                submitCount: 0,//提交人数
                questions: [],
                calcData: {},//小题集合
                answerList: [],
                userList: [],
                totalStudentCount: 0,
                raisehandsList: [],// 举手人员列表
                commitStudents: [],
                unanswerStudents: [],
                studentAnswer: {},
                unSubmitList: [],
                unSubmitIds: [],
                activePattern: 1,
                previewMode: false,
                previewVideoMode: false,
                videoSrc: ""
            }
        },
        methods: {
            /**
             * 点击图片模式
             */
            changePhotoPattern (e) {
                if (e.currentTarget.className.indexOf("activePattern") > -1) {
                    e.currentTarget.className = "photoPattern";
                    e.currentTarget.nextElementSibling.className = "listPattern activePattern";
                    this.activePattern = 2;
                } else {
                    e.currentTarget.className = "photoPattern activePattern";
                    e.currentTarget.nextElementSibling.className = "listPattern";
                    this.activePattern = 1;
                }
            },
            /**
             * 点击名单模式
             */
            changeListPattern (e) {
                if (e.currentTarget.className.indexOf("activePattern") > -1) {
                    e.currentTarget.className = "listPattern";
                    e.currentTarget.previousElementSibling.className = "photoPattern activePattern";
                    this.activePattern = 1;
                } else {
                    e.currentTarget.className = "listPattern activePattern";
                    e.currentTarget.previousElementSibling.className = "photoPattern";
                    this.activePattern = 2;
                }
            },
            /**
             * 获取userList
             */
            loadUserList () {
                var _this = this;
                _this.getData({
                    url: _this.interactPBPath + this.workId + "%2Fuserlist.pb",
                    pb: _this.userListPB,
                    success: function (resp) {
                        try {
                            if (Object.keys(resp).length === 0) { // 判断指定参数是否是一个空对象
                                var logStr = "学生列表:" + JSON.stringify(resp);
                                console.error(logStr);
                            }
                            _this.loadUserObj(resp);
                            _this.getInertactInfo();
                        }
                        catch (error) {
                            console.error(error);
                        }
                    },
                    fail: function () {
                        console.error("get resource err url=" + _this.interactPBPath + this.workId + "%2Fuserlist.pb");
                    }
                });
            },
            /**
             *  处理学生对象
             */
            loadUserObj (u) {
                // localStorage.setItem('stuListLength',u.userlist.length);
                for (var i = 0; i < u.userlist.length; i++) {
                    var uid = u.userlist[i].stuid.replace(/m_/g, '');
                    this.students[uid] = decodeURIComponent(u.userlist[i].stuname);
                    this.userList.push(uid);
                }
                this.totalStudentCount = Object.keys(this.students).length;
            },
            /**
             * 根据报告id获取报告详情
             */
            async getInertactInfo () {
                var _this = this;
                _this.getData({
                    url: _this.interactPBPath + this.workId + "%2Fwork.pb",
                    pb: _this.questionInfoPb,
                    success: function (resp) {
                        try {
                            _this.workJson = resp;
                            _this.loadWorkObj(resp);
                            _this.loadCalcJson();
                        }
                        catch (error) {
                        }
                    },
                    fail: function () {
                        console.error("get resource err url=" + _this.interactPBPath + this.workId + "%2Fwork.pb");
                    }
                });
            },
            getData (option) {
                // fetcdhGET(option.url + "?version=" + new Date().getTime(), {resType: "arraybuffer"}).then((resp) => {
                //     var res = option.pb.decode(resp);
                //     console.log(res);
                //     option.success(res);
                // }, (error) => {
                //     console.error(error);
                //     option.fail();
                // });

                API.GET(option.url + "?version=" + new Date().getTime()).then(function (resp) {
                    var res = option.pb.decode(resp.data);
                    console.log(res);
                    option.success(res);
                }).catch(function (error) {
                    console.error(error);
                    option.fail();
                });
            },
            initProtobuf () {
                if (typeof dcodeIO === 'undefined' || !dcodeIO.ProtoBuf) {
                    throw(new Error("ProtoBuf.js is not present."));
                }
                // 创建ProtoBuf
                var ProtoBuf = dcodeIO.ProtoBuf;
                var ClsModel = ProtoBuf.loadProtoFile("/static/pb/cls.proto");

                this.userListPB = ClsModel.build("UserList");
                this.questionInfoPb = ClsModel.build("QuestionInfoPb");
                this.calcPB = ClsModel.build("CalcPb");
                this.quesDetailsPb = ClsModel.build("QuesDetailsPb");
                this.StuAnswerPb = ClsModel.build("StuAnswerPb");
            },
            loadWorkObj (w) {
                let workname = decodeURIComponent(this.workJson.workname);
                // this.groupnum = w.stugroup;
                // this.wType = w.worktype;
                // this.qtype = w.questype;
                this.questions = w.questions;
                // this.workjson = w.workjson;
                //拼接题面图片集合
                let picArray = this.workJson.imgpaths;
                let teacherUid = this.workJson.userid;
                for (let i = 0; i < picArray.length; i++) {
                    let item = this.interactPath + "/upload/" + teacherUid + "/" + picArray[i];
                    this.picUrls.push(item);
                }
                let quesArray = this.workJson.questions;
                for (let i = 0; i < quesArray.length; i++) {
                    this.answerList.push(quesArray[i].answer);
                }

                //初始化题面swiper
                this.initQuesImgSwiper();
            },
            /**
             * 初始化题面swiper
             */
            initQuesImgSwiper () {

                this.$nextTick(() => {
                    // 如果题面为横图，则宽为100%。竖图高为100%,否则宽高都为100%
                    var img_url = this.picUrls[0];
                    // 创建对象
                    var img = new Image();
                    // 改变图片的src
                    img.src = img_url;
                    // 加载完成执行
                    // img.onload = function(){
                    //     // 打印
                    //     var imgWidth = img.width;
                    //     var imgHeight = img.height;
                    //     if(imgWidth >= imgHeight){
                    //         $(".item-img").css({'width':'100%'})
                    //     } else{
                    //         $(".item-img").css({'height':'100%'})
                    //     }
                    // };

                    // var swiper = new Swiper('.swiper-container', {
                    //     pagination: {
                    //         el: '.swiper-pagination',
                    //         type: 'fraction'
                    //     },
                    //     navigation: {
                    //         nextEl: '.swiper-button-next',
                    //         prevEl: '.swiper-button-prev'
                    //     }
                    // });
                });
            },
            /**
             * 转换题目类型为中文
             */
            getQuestype (questype) {
                var workName = '';
                switch (questype) {
                    case 'choice':
                        workName = '选择题';
                        break;
                    case 'judge':
                        workName = '判断题';
                        break;
                    case 'subject':
                        workName = '主观题';
                        break;
                    default:
                        workName = '填空题';
                }
                return workName;
            },
            /**
             * 小题统计
             */
            loadCalcJson () {
                var _this = this;
                _this.getData({
                    url: _this.interactPBPath + this.workId + "%2Fcalc.pb",
                    pb: _this.calcPB,
                    success: function (resp) {
                        try {
                            _this.submitCount = parseInt(resp.stuCount);
                            _this.calcData = resp.calc;
                            _this.loadCalcData(resp);
                        }
                        catch (error) {
                            console.error(error);
                        }
                    },
                    fail: function () {
                        _this.loadNoCalc && _this.loadNoCalc();
                    }
                });
            },
            /**
             * 没有学生提交时加载页面（未提交人数）
             */
            loadNoCalc () {
                this.totalStudentCount = Object.keys(this.students).length;
                for (var id in this.students) {
                    if (this.commitStudents.indexOf(id) == -1) {
                        this.unanswerStudents.push(id);
                    }
                }
            },
            loadCalcData (c) {
                var _this = this;
                this.totalStudentCount = Object.keys(_this.students).length;
                for (var i = 0; i < c.calc.length; i++) {
                    if (c.calc[i].questype == "subject") {
                        //主观题rightids代表所有提交学生
                        var rightIds = c.calc[i].rightids.split(',');
                        for (var j = 0; j < rightIds.length; j++) {
                            if (_this.commitStudents.indexOf(rightIds[j]) == -1) {
                                _this.commitStudents.push(rightIds[j]);
                                _this.studentAnswer[rightIds[j]] = new Array;
                            }
                        }
                    }
                }

                var loadIndex = 0;
                for (var i = 0; i < _this.commitStudents.length; i++) {
                    if (!_this.commitStudents[i]) {
                        _this.commitStudents.splice(i, 1);
                    }
                }
                for (var i = 0; i < _this.commitStudents.length; i++) {
                    var url = _this.interactPBPath + _this.workId + "/" + _this.commitStudents[i] + ".pb";
                    console.log('---------url: ' + url);
                    var _this = this;
                    _this.getData({
                        url: url,
                        pb: _this.StuAnswerPb,
                        success: function (resp) {
                            loadIndex++;
                            _this.loadUserAnswer(resp);
                        },
                        fail: function () {
                        }
                    });
                }
            },
            /**
             * 加载学生答案数据
             */
            loadUserAnswer (userAnswer) {
                console.log('---------userAnswer: ' + userAnswer);
                var uid = userAnswer.userid;
                var answerArray = userAnswer.answers;
                for (var i = 0; i < answerArray.length; i++) {
                    if (answerArray[i].questype == "subject") {
                        var qidAnswer = {};
                        qidAnswer.qid = answerArray[i].quesid;
                        qidAnswer.picUrls = new Array();
                        var picArray = answerArray[i].imgpaths;
                        for (var j = 0; j < picArray.length; j++) {
                            var item = this.interactPath + "/upload/" + uid + "/" + picArray[j];
                            qidAnswer.picUrls.push(item);
                        }
                        this.studentAnswer[uid].push(qidAnswer);
                    }
                }

                this.$forceUpdate();
            },
            /**
             * 处理学生答案数据
             */
            operUserAnswer () {
                for (var i = 0; i < this.commitStudents.length; i++) {
                    var nameList = [];
                    var imgList = [];// 图片url数组
                    var uid = this.commitStudents[i];
                    var name = this.students[uid]; // 当前学生姓名
                    var answerImgs = this.studentAnswer[uid][0].picUrls; // 当前学生提交的图片
                    // 获取学生提交图片数组 + 提交的学生姓名数组
                    for (var j = 0; j < answerImgs.length; j++) {
                        imgList.push(answerImgs[j]);
                        nameList.push(name);
                    }
                    this.commitStudents[i].nameList = [];
                    this.commitStudents[i].imgList = [];
                    this.commitStudents[i].nameList = nameList;
                    this.commitStudents[i].imgList = imgList;
                }
            },
            /**
             * 根据题目id获取每一题的举手人员列表
             */
            getHandsList (quesid) {
                let _this = this;
                _this.raisehandsList = [];
                for (var i = 0; i < _this.calcData.length; i++) {
                    if (quesid == _this.calcData[i].quesid) {
                        _this.raisehandsList = _this.calcData[i].raisehands.split(',');
                        break;
                    }
                }
                return _this.raisehandsList;
            },
            /**
             * 获取未提交的人员id数组和name数组
             */
            findUnSubmitData () {
                let _this = this;
                // var unSubmitIds = [];
                for (var id in _this.students) {
                    if (_this.commitStudents.indexOf(id) === -1) {
                        _this.unSubmitList.push(_this.students[id]);  //未提交人员姓名数组
                        _this.unSubmitIds.push(id); // 未提交人员id数组
                    }
                }
            },
            /**
             * 预览图片
             */
            previewAnswerImg (imgArr,index) {
                this.previewMode = true;
                //处理图片集合
                this.$refs.previewSlider.swiperInitByImgArr(this.convertImgArr(imgArr),index);
            },
            // 关闭预览
            closePreview (type) {
                this[type] = false;
            },
            /**
             *处理图片集合
             */
            convertImgArr (imgArr) {
                let imgArrData = [];
                imgArr.forEach(function (item) {
                    let imgObj = {};
                    imgObj.url = item;
                    imgArrData.push(imgObj);
                });

                return imgArrData;
            }
        },
        mounted () {
            //根据报告id获取报告详情
            this.initProtobuf();
            this.loadUserList();
        }
    }
</script>

<style lang="css" scoped>
    @import "../../../../style/cloudReport/normalize.css";
    @import "../../../../style/cloudReport/main.css";
    @import "../../../../style/cloudReport/objectReport.css";
</style>
<style lang="css">
    .swiper-container {
        width  : 100%;
        height : 100%;
    }

    .swiper-slide {
        text-align              : center;
        font-size               : 18px;
        background              : #fff;

        /* Center slide text vertically */
        display                 : -webkit-box;
        display                 : -ms-flexbox;
        display                 : -webkit-flex;
        display                 : flex;
        -webkit-box-pack        : center;
        -ms-flex-pack           : center;
        -webkit-justify-content : center;
        justify-content         : center;
        -webkit-box-align       : center;
        -ms-flex-align          : center;
        -webkit-align-items     : center;
        align-items             : center;
    }
</style>
